(function () {
  function qs(root, sel) { return root.querySelector(sel); }
  function qsa(root, sel) { return Array.from(root.querySelectorAll(sel)); }

  function getProductSection(wrapper) {
    return wrapper.closest('section') || document;
  }

  function getQuantity(productSection) {
    const qtyInput = qs(productSection, 'input[name="quantity"]');
    const qty = qtyInput ? parseInt(qtyInput.value || "1", 10) : 1;
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function getVariantId(productSection) {
    const idInput = qs(productSection, 'form[action*="/cart/add"] input[name="id"]');
    return idInput ? idInput.value : null;
  }

  function updateRows(wrapper, qty) {
    const rows = qsa(wrapper, '.gt-attendees__row');
    rows.forEach((row) => {
      const idx = parseInt(row.dataset.index, 10);
      row.hidden = !(idx <= qty);
    });
  }

  function readAttendees(wrapper, qty) {
    const attendees = [];
    for (let i = 1; i <= qty; i++) {
      const nameEl = qs(wrapper, '#gt_attendee_name_' + i);
      const dobEl = qs(wrapper, '#gt_attendee_dob_' + i);

      const name = (nameEl && nameEl.value ? nameEl.value : '').trim();
      const dob = (dobEl && dobEl.value ? dobEl.value : '').trim(); // yyyy-mm-dd

      attendees.push({ name: name, dob: dob });
    }
    return attendees;
  }

  function findMissing(attendees) {
    for (let i = 0; i < attendees.length; i++) {
      if (!attendees[i].name || !attendees[i].dob) return i;
    }
    return -1;
  }

  function isFutureDate(yyyyMmDd) {
    if (!yyyyMmDd) return false;
    const inputDate = new Date(yyyyMmDd + 'T00:00:00');
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return inputDate > today;
  }

  async function addLineItem(variantId, properties) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1,
        properties: properties
      })
    });

    if (!res.ok) {
      const text = await res.text();
      throw new Error(text || 'Add to cart failed');
    }

    return res.json();
  }

  function setError(box, msg) {
    box.textContent = msg;
    box.hidden = !msg;
  }

  function bind(wrapper) {
    const productSection = getProductSection(wrapper);
    const errorBox = qs(wrapper, '.gt-attendees__error');
    const btn = qs(wrapper, '.gt-attendees__checkout');

    function sync() {
      const qty = getQuantity(productSection);
      updateRows(wrapper, qty);
      setError(errorBox, '');
    }

    sync();

    const qtyInput = qs(productSection, 'input[name="quantity"]');
    if (qtyInput) {
      qtyInput.addEventListener('change', sync);
      qtyInput.addEventListener('input', sync);
    }

    btn.addEventListener('click', async function () {
      setError(errorBox, '');

      const variantId = getVariantId(productSection);
      if (!variantId) {
        setError(errorBox, 'Could not detect the selected variant. Please refresh and try again.');
        return;
      }

      const qty = getQuantity(productSection);
      updateRows(wrapper, qty);

      const attendees = readAttendees(wrapper, qty);
      const missingIndex = findMissing(attendees);

      if (missingIndex !== -1) {
        setError(errorBox, 'Please fill in the full name and date of birth for ticket holder ' + (missingIndex + 1) + '.');
        return;
      }

      const futureIndex = attendees.findIndex((a) => isFutureDate(a.dob));
      if (futureIndex !== -1) {
        setError(errorBox, 'Date of birth for ticket holder ' + (futureIndex + 1) + ' cannot be in the future.');
        return;
      }

      btn.disabled = true;

      try {
        // Add N separate lines, quantity 1, each with its own properties
        for (let i = 0; i < qty; i++) {
          await addLineItem(variantId, {
            'Ticket holder name': attendees[i].name,
            'DOB': attendees[i].dob
          });
        }

        window.location.href = '/checkout';
      } catch (e) {
        console.error(e);
        setError(errorBox, 'Something went wrong adding tickets. Please try again.');
      } finally {
        btn.disabled = false;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.gt-attendees').forEach(bind);
  });
})();
